export default {
  BusinessStockDistributionRatioAddWarehouse: {
    basicInformation: 'Account Information',
    supportWarehouseType: 'Supply Warehouse Type:',
    supportWarehouseId: 'Supply Warehouse Name:',
    realPosition: 'Real Warehouse',
    supportWarehouseCode: 'Supply Warehouse Code:',
    commodityDetails: 'Product Details',
    addGoods: 'Add Product',
    receivingWarehouse: 'Receiving Warehouse',
    qtyVirtual: 'Add Quantity Virtual Warehouse',
    interlineVirtual: 'Add Transfer Virtual Warehouse',
    title: 'Select Warehouse',
    receiveWarehouseCodeText: 'Please enter the code',
    receiveWarehouseNameText: 'Please enter the name',
    selectCommodity: 'Select Product',
    spuNameText: 'Please enter the product name',
    spuCodeText: 'Please enter the product code',
    skuCodeText: 'Please enter the SKU code',
    categoryIdText: 'Please select a category',
    msgWaring1: 'Please select a product first',
    msgWaring2: 'Please select the receiving warehouse first',

    table: {
      categoryName: 'Product Category',
      spuCode: 'Product Code',
      spuName: 'Product Name',
      skuCode: 'SKU',
      receiveTypeCode: 'Warehouse Type',
      receiveCode: 'Warehouse Code',
      receiveName: 'Warehouse Name',
      distributionQty: 'Product Bin Ratio',
      structureDistributionQty: 'Warehouse Structure Ratio'
     }
  }
};
